module.exports = __webpack_public_path__ + "img/電気回路_4_7_4.802ab101.png";